"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../../../index");
var MESSAGE_TYPE;
(function (MESSAGE_TYPE) {
    MESSAGE_TYPE["INFORMATION"] = "INFORMATION";
    MESSAGE_TYPE["IMPORTANT"] = "IMPORTANT";
    MESSAGE_TYPE["CONVERSATION"] = "CONVERSATION";
})(MESSAGE_TYPE = exports.MESSAGE_TYPE || (exports.MESSAGE_TYPE = {}));
exports.storeDriverMessage = function (message) {
    return index_1.Model.makeRequest("/communications/functions/driver-messages", index_1.METHOD.POST, message);
};
